import React from "react";
import "../style/submitBtn.css";
export default function SubmitBtn(props){
    return props.active ? <div className="flex flexCol" onClick={props.click}>{props.content}</div>
    : <div className={props.loaderClass}>
        <div className={props.loadingCircle}></div>
    </div>
}